<template>
    <v-container class="my-2" >

        <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Barbeiros</h1>
        <v-layout row justify-space-around >

                <v-flex class="ma-5 pa-5"  >
                <NovoBarbeiroDialog  :acaoEditar='false' @recarregarLista="carregarListasAtualizadas" />
                
                </v-flex>

            </v-layout>
        <v-layout row >
            
            <v-flex xs12 sm6 md4  v-for="item in items" :key="item.id" >
                <v-card class="text-center ma-3 pa-3 grey lighten-2"  >
                <v-card class="green white--text mb-5"  > {{ item.nome }}</v-card>

                    <v-responsive>
                        <v-avatar size="100" class="black lighten-1" >
                            <img src="/imgs/barbeiro_perfil.jpg" alt="">
                        </v-avatar>
                    </v-responsive>
                    <v-card-text>
                        <div class="subheading">
                            {{ item.nome }}
                        </div>
                        <div class="grey--text">
                            {{ item.nascimento }}
                        </div>

                        <v-divider></v-divider>
                        <!-- <div v-if="item.funcoes" class="green lighten-4" >
                            <p class="subheading green lighten-2 mb-1" >Serviços</p>
                            <div v-for="func in item.funcoes" :key="func.id" >
                                <v-chip class="mb-1 green" dark>
                                    {{ func.descricao }}
                                </v-chip>
                            </div>
                        </div>
                        -->

                    </v-card-text>
                    <v-card-actions>
                        <v-layout row justify-center >
                                
                            <NovoBarbeiroDialog  :acaoEditar='true' 
                                @recarregarLista="carregarListasAtualizadas"
                                    :itemPassado="item" />
                                  
                                  <FuncoesBarbeiroDialog :barbeiro="item" @recarregarLista="carregarListasAtualizadas" />
                               
                                    <Horarios :barbeiro="item" @recarregarLista="carregarListasAtualizadas" /> 
                                 
                          
                                <v-btn class="red ma-2" dark @click="removerBarbeiro(item)" >
                                    <v-icon left>mdi-delete</v-icon>
                                    <span>Remover</span>
                                </v-btn>
                            
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>



         
    


   
    </v-container>

    
</template>

<script>
import NovoBarbeiroDialog from "./Components/NovoBarbeiroDialog"
import FuncoesBarbeiroDialog from "./Components/FuncoesBarbeiroDialog"
import Horarios from "./Components/Horarios"
//import firebase from 'firebase'
import {refFuncoes, refBarbeiros, refUsers} from '@/firebaseConfig'
import {mapActions } from 'vuex'

    export default {
        components: {
            NovoBarbeiroDialog,
            FuncoesBarbeiroDialog,
            Horarios
        },
        data(){
            return {
                dbRef: refBarbeiros,
                dbRefFuncoes: refFuncoes,
                refUsers: refUsers,
                items:[]
            }
        },
        async created(){
            await this.carregarLista();
            this.carregarFuncoes();
        },
        beforeCreate(){
           console.log("store", this.$store.state.userLvl);
           
        },
        methods: {
            ...mapActions(["deleteUserAuth"]),
            checarAuth(){
                if(this.$store.getters.getUserLevel > 2){
                    console.log("permitido");
                }else{
                    console.log("nao permitido");
                }
            },
            async carregarListasAtualizadas(){
            await this.carregarLista();
            this.carregarFuncoes();
            },
             async carregarLista(){
                this.items = [];
                 return this.dbRef.get().then(  (snap) =>  {
                     snap.forEach( (doc) =>  {
                        
                        this.items.push({...doc.data()});
                    });
                });
            },
            async carregarFuncoes(){
                    let barbeiros = [];
                    await this.items.forEach(async(barb)=> {
                            console.log("barb")
                        
                        if(barb.funcoes){
                            let funcoes = barb.funcoes
                            barb.funcoes = []
                            await funcoes.forEach(async(f)=>{

                                barb.funcoes.push({...await this.dbRefFuncoes.doc(f).get().then((doc) => { return doc.data()})});
                                
                                
                            });
                            barbeiros.push({...barb})
                        }else{
                            barbeiros.push({...barb})
                        }

                        
                    });
                    console.log(barbeiros)
                    this.items = []
                  this.items = barbeiros;
            },
            removerBarbeiro(item){
                //TODO remover usuário do AUTH também
                //Criar uma function
                if(confirm("Deseja excluir mesmo o barbeiro " + item.nome + "?")){
                  
                    refUsers.where("email", "==", item.email).get().then((snap)=>{
                    //console.log(snap.docs[0].data().uid);
                        refUsers.doc(snap.docs[0].data().uid).delete().then(()=>{
                               this.dbRef.doc(item.id).delete().then(() => {
                                console.log("Apagado");

                                this.carregarLista()
                                });
                        }).catch(err=>{
                            alert(err.message)
                        });
                    }).catch(err =>{
                            alert(err.message)
                    });
                    
                   /* if(this.deleteUserAuth(snap.docs[0].data().uid)){
                       this.dbRef.doc(item.id).delete().then(() => {
                        console.log("Apagado");

                            this.carregarLista()

                      });
                    }else{
                        console.log("Erro ao excluir USER AUTH");
                    }*/
      
                }else{
                    console.log("Ação cancelada")
                }
                
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>